

export const openHelp = () => {
    window.open("https://docs.zerofootprintclient.nl", '_blank').focus();
}

